import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Account } from '@air/api';
import { type Account as TAccount } from '@air/api/types';
import { callAirApi } from '@air/utils-api';

import { getAccountKey } from '~/swr-hooks/account/useAccount';

export const usePrivateAccountDeletePendingEmailMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return callAirApi(() => Account.deletePendingEmail({}));
    },

    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: getAccountKey() });
      const previousAccount = queryClient.getQueryData<TAccount>(getAccountKey());

      if (previousAccount) {
        queryClient.setQueryData<TAccount>(getAccountKey(), { ...previousAccount, pendingEmail: null });
      }

      return { previousAccount };
    },

    onError: (_error, _variables, context) => {
      if (context?.previousAccount) {
        queryClient.setQueryData(getAccountKey(), context.previousAccount);
      }
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: getAccountKey() });
    },
  });
};
